/* eslint-disable react/no-danger */
/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import { track } from 'services/tracking';
import {
  FlashMessagesNotificationState,
  FlashMessagesNotificationTypes,
} from 'store/modules/flash_message_notification_store/types';

import * as S from './styles';

const FlashMessageNotification = () => {
  const { flash_messages_notification, feedback_notification } = useSelector<
    ApplicationState,
    FlashMessagesNotificationState
  >((state) => state.session.flash_messages_notification);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!feedback_notification.show) return;
    setTimeout(() => {
      dispatch({ type: FlashMessagesNotificationTypes.READ_FEEDBACK });
    }, 5000);
  }, [feedback_notification]);

  const abrirBanner = () => {
    const { url, boleto_receita_id } = flash_messages_notification;
    if (boleto_receita_id) {
      const hoje = new Date().toISOString().slice(0, 10);
      track(
        'conversao.gerou_boleto',
        { receita: boleto_receita_id, segunda_via: true },
        undefined,
        `${boleto_receita_id}:2via:${hoje}`,
      );
    }
    window.location.href = url;
  };

  return (
    <>
      {flash_messages_notification.show && (
        <S.FlashMessage
          className={`alert p-2 text-center mb-0 ${
            flash_messages_notification.expired ? 'alert-danger' : 'alert-warning'
          }`}
        >
          <button type="button" className="btn p-1 btn-link alert-link" onClick={abrirBanner}>
            <strong>
              <div dangerouslySetInnerHTML={{ __html: flash_messages_notification.text }} />
            </strong>
          </button>
        </S.FlashMessage>
      )}

      {feedback_notification.show && (
        <S.FeedbackMessage
          className={`alert p-2 mt-2 text-center mb-0 alert-${feedback_notification.class}`}
        >
          <strong>
            <div dangerouslySetInnerHTML={{ __html: feedback_notification.text }} />
          </strong>
        </S.FeedbackMessage>
      )}
    </>
  );
};

export default FlashMessageNotification;
